/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const PatchedAccountSetDefaultVersionRequest = zod.strictObject({
    default_version: zod.number().optional(),
});

export type PatchedAccountSetDefaultVersionRequest = zod.input<
    typeof PatchedAccountSetDefaultVersionRequest
>;
export type PatchedAccountSetDefaultVersionRequestOutput = zod.output<
    typeof PatchedAccountSetDefaultVersionRequest
>;
